import { __decorate } from "tslib";
import { Injectable, inject } from '@angular/core';
import { Observable, map, of, defer, EMPTY, concat, ignoreElements } from 'rxjs';
import _ from 'lodash';
import { SailsSocketService } from '../../modules/sails-socket';
let SiteService = class SiteService {
    sails = inject(SailsSocketService);
    sites = new Map();
    _model = { array: [], byId: {}, byOrg: {} };
    get model() {
        return this._model;
    }
    getSites() {
        return this.createObservable('/site').pipe(map(({ data }) => {
            data.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
            this.updateModel(data);
            return this.model;
        }));
    }
    getSitesForOrg(org) {
        const byOrg$ = defer(() => of(this._model.byOrg[org] || []));
        const retrieveSites$ = this.sites.size ? EMPTY : this.getSites();
        return concat(retrieveSites$.pipe(ignoreElements()), byOrg$);
    }
    updateModel(data) {
        this.sites.clear();
        this._model.array = [];
        this._model.byId = {};
        this._model.byOrg = {};
        _.forEach(data, (site) => {
            this.sites.set(site.id, site);
            this._model.array.push(site);
            this._model.byId[site.id] = site;
            this._model.byOrg[site.org] = this._model.byOrg[site.org] || [];
            this._model.byOrg[site.org].push(site);
        });
    }
    createObservable(url, method = 'get', data) {
        return new Observable((subscriber) => {
            const subscription = this.sails[method](url, data).subscribe({
                next: (response) => {
                    subscriber.next(response);
                    subscriber.complete();
                },
                error: (error) => subscriber.error(error),
            });
            return () => subscription.unsubscribe();
        });
    }
};
SiteService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], SiteService);
export { SiteService };
